

// TextField.js

import React from 'react'
import '../../styles/text/TextField.css';

const TextField = ({ text, children, bold = false, fontSize = '1rem', fontColor = '#222222', className = '' }) => {
    return (
        <div className={`text-field-container ${className}`}>
            <p className='text-field-p' style={{ fontWeight: bold ? 700 : 400, fontSize, color: fontColor }}>
            {children || text}
            </p>
        </div>
        
    );
}


export default TextField